import moment from "moment/moment";
import React, { useEffect, useState } from "react";
import api from "../../setupMiddleware";
import AttendanceLogCalendar from "../Common/AttendanceLogCalendar";
import useApiLoader from "../../Utils/useApiLoader";
import Loader from "../Loader/Loader";
import AttendanceLogTable from "../Common/AttendanceLogTable";
import Popup from "../Common/Popup";
import PlaceholderImage from "../../assets/images/placeholder.jpg";
import StatCard from "../Common/StatCard";
import UsersIcon from "../../assets/icons/users";
import NoteIcon from "../../assets/icons/note";
import LogIcon from "../../assets/icons/log";

const AttendanceLog = () => {
  const loading = useApiLoader();
  const [attendanceLogs, setAttendanceLogs] = useState([]);
  const [openImage, setOpenImage] = useState(false);
  const [selectedPhoto, setSelectedPhoto] = useState({});
  const [userSummary, setUserSummary] = useState({});

  const getAttendanceLogByDate = async (date) => {
    try {
      await api.post("/api/attendance-log", { date: date }).then((res) => {
        if (res && res.status === 200) {
          setAttendanceLogs(res.data?.data);
        }
      });
    } catch (error) {
      alert("Something went wrong!");
    }
  };

  const getUserSummary = async () => {
    try {
      api.get("/api/employees-summary").then((res) => {
        if (res && res.status === 200) {
          setUserSummary(res.data?.data);
        }
      });
    } catch (error) {
      console.log(error.res.data.message);
    }
  };

  const handleDateClick = (date) => {
    const formattedDate = moment(date).format("YYYY-MM-DD");
    getAttendanceLogByDate(formattedDate);
  };

  useEffect(() => {
    const today = moment(new Date()).format("YYYY-MM-DD");
    getAttendanceLogByDate(today);
  }, []);

  const handleTimeSelect = (pic) => {
    setSelectedPhoto(pic);
    setOpenImage(true);
  };

  const handleClosePhoto = () => {
    setSelectedPhoto("");
    setOpenImage(false);
  };

  useEffect(() => {
    getUserSummary();
  }, []);

  const stats = [
    {
      title: "Total Employee",
      value: userSummary?.total ? userSummary.total : 0,
      Icon: UsersIcon,
    },
    {
      title: "Present Today",
      value: userSummary?.present_today ? userSummary.present_today : 0,
      Icon: NoteIcon,
    },
    {
      title: "Employee On Leave",
      value: userSummary?.on_leave ? userSummary.on_leave : 0,
      Icon: LogIcon,
    },
    {
      title: "Absent Today",
      value: userSummary?.absent ? userSummary.absent : 0,
      Icon: NoteIcon,
    },
  ];

  return (
    <>
      {loading && <Loader opacity={90} fullscreen />}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center w-full mx-auto px-4 py-3 gap-4">
        <p>
          <span className="block text-xl sm:text-2xl font-medium text-[#de2b26]">
            Attendance
          </span>
          <span className="block text-sm text-[#142b70]/50">
            Check Attendance logs of All Employees
          </span>
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 w-full mx-auto px-4 py-3">
        {stats.map((stat, index) => (
          <StatCard key={index} {...stat} />
        ))}
      </div>
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center w-full mx-auto px-4 py-3 gap-4">
        <AttendanceLogCalendar onDateClick={handleDateClick} />
      </div>
      <div className="w-full mx-auto px-4 py-3 relative">
        <div className="w-full mx-auto px-4 py-3 relative rounded-xl bg-white border border-[#a48572]/10">
          <div className="flex flex-col justify-start items-start gap-[20px]">
            <div className="flex flex-col justify-start items-start flex-grow-0 flex-shrink-0 relative gap-5">
              <p className="flex-grow-0 flex-shrink-0 text-base font-medium text-left text-[#142b70]">
                Attendance History
              </p>
            </div>
            <AttendanceLogTable
              data={attendanceLogs}
              handleSelectTime={handleTimeSelect}
            />
            <Popup
              isOpen={openImage}
              onClose={handleClosePhoto}
              title="Check In / Out Image"
            >
              <div className="flex flex-col md:flex-row items-start gap-6 mt-[30px]">
                <div className="flex flex-col gap-4 w-full md:w-1/2 mb-8">
                  <div className="text-[#c30f0a] text-lg">Check In Image</div>
                  <img
                    src={
                      selectedPhoto?.checkInImg
                        ? selectedPhoto?.checkInImg
                        : PlaceholderImage
                    }
                    alt="Check In Image"
                    className="w-full h-52 object-cover rounded-lg shadow-md"
                  />
                </div>
                <div className="flex flex-col gap-4 w-full md:w-1/2 mb-8">
                  <div className="text-[#c30f0a] text-lg">Check Out Image</div>
                  <img
                    src={
                      selectedPhoto?.checkOutImg
                        ? selectedPhoto?.checkOutImg
                        : PlaceholderImage
                    }
                    alt="Check Out Image"
                    className="w-full h-52 object-cover rounded-lg shadow-md"
                  />
                </div>
              </div>
            </Popup>
          </div>
        </div>
      </div>
    </>
  );
};

export default AttendanceLog;
